export const useScrollTop = (selector: string) => {
  const content = document.querySelector(selector)
  if (content) {
    content.scrollTop = 0
    content.scrollIntoView({block: 'center', behavior: 'smooth'})
  }
}